export const dashboard={
    dashboard_title:"Tableau de bord",
    advanced_dashboard_title:"Statistiques avancées",
    products:"Produits",
    shipping_modes:"Modes d'expédition"
}
